import { Group, Path, Segment } from "paper/dist/paper-core";
import { BORDER_COLOR, CANVAS_CENTER } from "../../constants";

const EAR_TOP = 37;
const EAR_BOTTOM = 47;
const CANVAS_CENTER_OFFSET = 16;

const LEFT_EAR_X = CANVAS_CENTER - CANVAS_CENTER_OFFSET;
const RIGHT_EAR_X = CANVAS_CENTER + CANVAS_CENTER_OFFSET;

export default class Ears extends Group {
  constructor() {
    const right = new Path({
      segments: [
        new Segment({
          point: [RIGHT_EAR_X, EAR_TOP],
          handleOut: [5, 2],
        }),
        new Segment({
          point: [RIGHT_EAR_X, EAR_BOTTOM],
          handleIn: [3, -1],
        }),
      ],
      strokeColor: BORDER_COLOR,
      strokeWidth: 1,
    });

    const left = new Path({
      segments: [
        new Segment({
          point: [LEFT_EAR_X, EAR_TOP],
          handleOut: [-5, 2],
        }),
        new Segment({
          point: [LEFT_EAR_X, EAR_BOTTOM],
          handleIn: [-3, -1],
        }),
      ],
      strokeColor: BORDER_COLOR,
      strokeWidth: 1,
    });

    super([right, left]);
  }
}
